import client from '@/plugins/axios.js'

export default  {
    authenticate(payload){
        return client({requiresAuth:false}).post('/api/login_check',payload)
    },
    me(){
        return client({requiresAuth:true}).get('/api/me')
    },
    dealer(){
        return client({requiresAuth:true}).get('/api/dealer')
    },
    addNewAddress(payload) {
        return new Promise((resolve,reject)=>{
            client({requiresAuth:true}).post('/api/dealer/address', payload)
                .then((res)=>{
                    resolve(res.data.data)

                })
                .catch((err)=> {
                    console.log(err)
                    reject(err)
                })
        })
    },
   deleteAddress(payload) {
        return new Promise((resolve,reject)=>{
            client({requiresAuth:true}).post('/api/dealer/address/'+payload+'/delete', payload)
                .then((res)=>{
                    resolve(res.data.data)

                })
                .catch((err)=> {
                    console.log(err)
                    reject(err)
                })
        })
    },
    listAllAddresses(){
        return new Promise((resolve,reject)=> {
            client({requiresAuth: true}).get('/api/dealer/address/list')
                .then((res) => {

                    resolve(res.data?.data)
                })
                .catch((err) => {
                    reject(err)
                })
        })
    }
}
